
<template>
  <div>
    <section>

      <Breadcrumbs
        :breadcrumbs="breadcrumbs"
      >
        <div slot="breadcrumbAfter" class="d-flex align-items-center">
            <va-dropdown
              v-if="showDropdown"
              class="custom-dropdown"
              fixed>

              <span slot="anchor">
                <slot>
                  <div class="pl-3 pr-2 clickable">
                    <span class="fa fa-ellipsis-v" style="font-size: 1.5rem;"></span>
                  </div>
                </slot>
              </span>

              <div class="contact-dropdown__content pl-3 pr-2 pt-2 pb-2">

                <!-- Edit Kiosk -->
                <div
                  class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                  v-if="canUpdateKiosk"
                  @click.prevent="onClickUpdateKiosk"
                >
                  <i class="fa fa-pencil custom-icon px-2"></i>&nbsp;
                  <span class="pl-2">{{$t('licenses.actions.edit_kiosk')}}</span>
                </div>

                <!-- Edit License -->
                <div
                  class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                  v-if="canUpdateLicense"
                  @click.prevent="onClickUpdateLicense"
                >
                  <i class="fa fa-pencil custom-icon px-2"></i>&nbsp;
                  <span class="pl-2">{{$t('licenses.actions.edit_license')}}</span>
                </div>

                <!-- Renew License -->
                <div
                  class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                  v-if="canUpdateLicense"
                  @click.prevent="onClickRenewLicense"
                >
                  <i class="fa fa-pencil custom-icon px-2"></i>&nbsp;
                  <span class="pl-2">{{$t('licenses.actions.renew_license')}}</span>
                </div>

                <!-- Cancel License -->
                <div
                  class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2"
                  v-if="!isCanceledLicense"
                  @click.prevent="onClickCancelLicense"
                >
                  <i class="fa fa-times custom-icon px-2"></i>&nbsp;
                  <span class="pl-2">{{$t('licenses.actions.cancel_license')}}</span>
                </div>

              </div>
            </va-dropdown>
          </div>
      </Breadcrumbs>

      <fade-transition :duration="250" mode="out-in">
        <div v-if="selectedKiosk" class="mt-2">

          <div class="row">

            <div class="col-12 col-md-6">
              <h4 class="mb-0">{{$t('kiosks.kiosk_data')}}</h4>

              <KioskInfo
                :kiosk="selectedKiosk" />

            </div>

            <div class="col-12 col-md-6">

              <div class="d-flex justify-content-between align-items-center">
                <h4 class="mb-0">{{$t('kiosks.license_data')}}</h4>
              </div>

              <div v-if="selectedKiosk.active_license" class="mt-3">
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.name')}}:</span>
                  <span @click="redirectToLicense" class="col-12 col-md-8 link">{{selectedKiosk.active_license.name}}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.canceled')}}:</span>
                  <span v-if="selectedKiosk.active_license.canceled_at === null" class="col-12 col-md-8"> {{$t('rules.labels.0') }}</span>
                  <span v-else class="col-12 col-md-8" style="color:red">{{$t('rules.labels.1')+ ', '+ $t('licenses.canceled_by_date',
                    {name: selectedKiosk.active_license.canceled_by.name, timestamp: selectedKiosk.active_license.canceled_at})}}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.owner')}}:</span>
                  <span class="col-12 col-md-8">{{selectedKiosk.active_license.entity.name}}</span>
                </div>
                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.license_type')}}:</span>
                  <span class="col-12 col-md-8">{{$t(licenseTypesAdapter[selectedKiosk.active_license.license_type_id])}}</span>
                </div>
                <div class="row" v-if="isFromEvollu">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.start_date')}}:</span>
                  <span class="col-12 col-md-8">{{selectedKiosk.active_license.start_date}}</span>
                </div>
                <div class="row" v-if="isFromEvollu">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.end_date')}}:</span>
                  <span class="col-12 col-md-8">{{selectedKiosk.active_license.end_date}}</span>
                </div>

                <div class="row" v-if="isFromEvollu">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.invoice_number')}}:</span>
                  <span class="col-12 col-md-8">
                    {{selectedKiosk.active_license.invoice_number || 'N/A'}}
                  </span>

                </div>

                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.invoice_date')}}:</span>
                  <span class="col-12 col-md-8">{{selectedKiosk.active_license.invoice_date || 'N/A'}}</span>
                </div>

                <div class="row">
                  <span class="simple-label col-12 col-md-4">{{$t('licenses.invoice_amount')}}:</span>
                  <span class="col-12 col-md-8">{{selectedKiosk.active_license.invoice_amount || 'N/A' }}</span>
                </div>
              </div>

              <div v-else class="h-75 d-flex flex-column align-items-center justify-content-center">
                <span class="simpleLabel">{{$t('kiosks.no_license')}}</span>
                <va-button
                  v-if="hasWriteLicensePermissions"
                  @click.prevent="onClickCreateLicense">
                  {{$t('licenses.create')}}
                </va-button>
              </div>

            </div>

          </div>

          <SessionsList
            class="mt-5"
            v-if="selectedKiosk"
            :kiosk="selectedKiosk" />

        </div>

        <div v-if="!selectedKiosk" class="loading-widget text-center d-flex flex-column justify-content-center">

          <h6><b>{{$t('tables.loading')}}</b></h6>
          <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
        </div>
      </fade-transition>

    </section>

    <CreateOrUpdateKiosk
      v-if="isUpdatingKiosk"
      :kiosk="selectedKiosk"
      @updated="onKioskUpdated"
      @modalClosed="onKioskModalClosed" />

    <CreateOrUpdateLicense
      v-if="isUpdatingOrCreatingLicense"
      :isRenew="isRenewingLicense"
      :license="isRenewingLicense ? renewedLicense : selectedLicenseForUpdate"
      :kiosk="selectedKiosk"
      @created="onLicenseCreated"
      @updated="onLicenseUpdated"
      @destroyed="onLicenseDestroyed"
      @renewed="onLicenseRenewed"
      @modalClosed="onLicenseModalClosed" />

    <ConfirmationModal
      v-if="showCancelLicenseModal"
      :title="$t('licenses.cancel')"
      :body="$t('licenses.cancel_message')"
      @modal-confirmed="cancelLicense"
      @modal-canceled="cancelLicenseCanceled" />

  </div>
</template>

<script>
import Breadcrumbs from '@/components/common/Breadcrumbs'
import FadeTransition from '@/components/common/transitions/FadeTransition'
import { KiosksService } from '@/api/LeadsService'
import KioskInfo from '@/components/licenses/kiosks/KioskInfo'
import SessionsList from '@/components/licenses/kiosks/sessions/index'
import LoadingAnimation from '@/components/users/components/Helpers/LoadingAnimation'
import CreateOrUpdateLicense from '@/components/licenses/CreateOrUpdate'
import CreateOrUpdateKiosk from '@/components/licenses/kiosks/CreateOrUpdate'
import ConfirmationModal from "../../common/ConfirmationModal";
import {LicensesService} from "../../../api/LeadsService";
const licenseInfoType = 300
const leadsEntityInfoType = 110
const WriteAccessType = 2
const readAccessType = 1

export default {
  components: {
    ConfirmationModal,
    KioskInfo,
    Breadcrumbs,
    FadeTransition,
    LoadingAnimation,
    SessionsList,
    CreateOrUpdateLicense,
    CreateOrUpdateKiosk
  },
  computed: {
    breadcrumbs: function () {
      return [
        { title: this.$t('menu.audiology'), disabled: true },
        { title: this.$t('menu.kiosks'), meta: { type: 'function', value: () => this.$router.push({ name: `${this.leadsService.slug}licenses/kiosks` }) } },
        { title: this.selectedKiosk ? this.$t('kiosks.kiosk_name', { name: this.selectedKiosk.name, serial: this.selectedKiosk.serial }) : null, active: true },
      ]
    },
    leadsService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    hasWriteLicensePermissions: function () {
      return this.leadsService.user_permissions.some(permission => {
        return permission.info_type === licenseInfoType && permission.access_type >= WriteAccessType
      })
    },
    canUpdateKiosk: function () {
      if (!this.selectedKiosk || !this.selectedKiosk.active_license || !this.isFromEvollu) {
        return false
      }

      return this.leadsService.user_permissions.some(permission => {
        return permission.info_type === leadsEntityInfoType && permission.access_type >= readAccessType && (permission.entity_id === null || (this.selectedKiosk.active_license && permission.entity_id === this.selectedKiosk.active_license.entity.id))
      })
    },
    isCanceledLicense: function () {
      return this.canUpdateLicense && this.selectedKiosk.active_license.canceled_at !== null
    },
    canUpdateLicense: function () {
      return this.hasWriteLicensePermissions && this.selectedKiosk && this.selectedKiosk.active_license
    },
    isFromEvollu: function () {
      return this.$auth.user().entity.id === 1
    },
    showDropdown: function () {
      return this.canUpdateKiosk || this.canUpdateLicense
    }
  },
  data: function () {
    return {
      showCancelLicenseModal: false,
      isUpdatingOrCreatingLicense: false,
      isRenewingLicense: false,
      selectedLicenseForUpdate: undefined,
      isUpdatingKiosk: false,
      selectedKiosk: undefined,
      renewedLicense: undefined,
      from: undefined,
      licenseTypesAdapter: {
        1: 'licenses.types.standard',
        2: 'licenses.types.premium'
      },
    }
  },
  methods: {
    selectKiosk: function (kioskId) {
      KiosksService.get(kioskId, { with: 'leads' })
        .then(kiosk => {
          this.selectedKiosk = kiosk
        })
        .catch(errors => {
          this.redirectBack()
        })
    },
    redirectBack: function () {
      this.$router.go(-1)
    },
    onLicenseCreated: function (license) {
      this.isUpdatingOrCreatingLicense = false
      this.selectedKiosk.active_license = license
    },
    onLicenseUpdated: function (license) {
      this.isUpdatingOrCreatingLicense = false
      this.selectedKiosk.active_license = license
    },
    onLicenseDestroyed: function () {
      this.isUpdatingOrCreatingLicense = false
      this.selectedKiosk.active_license = null
    },
    onLicenseModalClosed: function () {
      this.isUpdatingOrCreatingLicense = false
    },
    redirectToLicense: function () {
      this.$router.push({ name: `${this.leadsService.slug}licenses/id`, params: { id: this.selectedKiosk.active_license.id } })
    },
    onClickUpdateLicense: function () {
      this.isUpdatingOrCreatingLicense = true
      this.selectedLicenseForUpdate = this.selectedKiosk.active_license
    },
    onClickCreateLicense: function () {
      this.isUpdatingOrCreatingLicense = true
      this.selectedLicenseForUpdate = null
    },
    onClickUpdateKiosk: function () {
      this.isUpdatingKiosk = true
    },
    onKioskModalClosed: function () {
      this.isUpdatingKiosk = false
    },
    onKioskUpdated: function (kiosk) {
      this.selectedKiosk = kiosk
    },
    onClickRenewLicense: function () {
      this.isRenewingLicense = true
      let license = JSON.parse(JSON.stringify(this.selectedKiosk.active_license))
      this.renewedLicense = Object.assign(license, {
        start_date: this.moment(license.end_date).format('YYYY-MM-DD'),
        end_date: this.moment(license.end_date).add(1, 'year').format('YYYY-MM-DD'),
        invoice_amount: null,
        invoice_date: null,
        invoice_number: null
      })
      this.isUpdatingOrCreatingLicense = true
    },
    onLicenseRenewed: function (license) {
      this.isUpdatingOrCreatingLicense = false
      this.isRenewingLicense = false
      this.selectedKiosk.active_license = license
    },
    onClickCancelLicense: function() {
      this.showCancelLicenseModal = true
    },
    cancelLicense: function () {
      LicensesService.cancel(this.selectedKiosk.active_license.id)
        .then((license) => {
          this.showToast(this.$t('licenses.states.canceled'), this.$store.state.successToastOptions)
          this.showCancelLicenseModal = false
          this.selectedKiosk.active_license = license
        }).catch(errors => {
          console.log(errors)
      })
    },
    cancelLicenseCanceled: function () {
      this.showCancelLicenseModal = false
      //this.showModal = true
    },
  },
  beforeRouteEnter (to, from, next) {
    if (to.params.id !== undefined) {
      next(vm => {
        vm.selectKiosk(parseInt(to.params.id))
        vm.from = from
      })
    } else {
      next(from)
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (to.params.id !== undefined) {
      this.selectKiosk(parseInt(to.params.id))
    } else {
      next(from)
    }
  }
}
</script>

<style scoped lang="scss">
.loading-widget {
  min-height: 60vh;
}

.simple-label {
  font-weight: bold;
  font-size: 17px;
}

.custom-icon {
  cursor: pointer;
  color: #29c4a9;
  font-size: 1.2rem;
}

.widget {
  height: calc(100% - 1.875rem) !important;
}

.contact-dropdown__item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
